module.exports = __webpack_public_path__ + "static/mailtagguide-e98fccfd0a080c3b624ce6ebc80f73c0.png";